export default class LogoColorChange {
  constructor() {
    this.header = document.getElementById('js-header');
    this.logo = this.header?.querySelector('.l-header__logo_link');
    this.colorChangeAreas = [...document.querySelectorAll('.js-logo_change_area')];
    this.activeClass = 'is-logo-color-change';
    this.frameId = null;

    if (!this.header || !this.logo || this.colorChangeAreas.length === 0) {
      return;
    }

    this.requestUpdate = this.requestUpdate.bind(this);
    this.init();
  }

  init() {
    this.update();
    window.addEventListener('scroll', this.requestUpdate, { passive: true });
    window.addEventListener('resize', this.requestUpdate, { passive: true });
  }

  requestUpdate() {
    if (this.frameId) {
      return;
    }

    this.frameId = window.requestAnimationFrame(() => {
      this.update();
      this.frameId = null;
    });
  }

  update() {
    const logoRect = this.logo.getBoundingClientRect();
    const logoCenterY = logoRect.top + logoRect.height / 2;
    const isOnColorChangeArea = this.colorChangeAreas.some(area => {
      const areaRect = area.getBoundingClientRect();
      return areaRect.top <= logoCenterY && areaRect.bottom >= logoCenterY;
    });

    this.header.classList.toggle(this.activeClass, isOnColorChangeArea);
  }
}
